import React, { useEffect, useState, useCallback } from 'react';
import debounce from 'lodash/debounce';

export const CustomTextarea = ({ placeholder = 'Please add details', storedValue = '', onValueChange = () => {} }) => {
  const [value, setValue] = useState(storedValue);
  // TODO: Fix hook dependencies
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const delayedQuery = useCallback(
    debounce((newValue) => onValueChange(newValue), 250),
    []
  );

  useEffect(() => {
    setValue(storedValue);
  }, [storedValue]);

  const onChange = (newValue) => {
    setValue(newValue);
    delayedQuery(newValue);
  };

  return <textarea placeholder={placeholder} onChange={(e) => onChange(e.target.value)} value={value} />;
};

export default CustomTextarea;
